import { CommodityFilterInput, CommodityStats } from '@bechtel/types';
import { useLazyQuery, QueryTuple } from '@apollo/client';
import { GET_COMMODITY_FITUP_STATS } from '@bechtel/client-gql';

export function useCommodityFitupStatsQuery(
  fetchFromNetwork?: boolean
): QueryTuple<{ commodityStats: CommodityStats }, { input: CommodityFilterInput }> {
  const response = useLazyQuery<{ commodityStats: CommodityStats }, { input: CommodityFilterInput }>(
    GET_COMMODITY_FITUP_STATS,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'no-cache',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
